import { render, staticRenderFns } from "./ViewCalendarEvent.vue?vue&type=template&id=18b36142&scoped=true&"
import script from "./ViewCalendarEvent.vue?vue&type=script&lang=js&"
export * from "./ViewCalendarEvent.vue?vue&type=script&lang=js&"
import style0 from "./ViewCalendarEvent.vue?vue&type=style&index=0&id=18b36142&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b36142",
  null
  
)

export default component.exports